






















import { defineComponent, onMounted, Ref, ref, SetupContext } from '@vue/composition-api';
import ElForm                                                 from 'element-ui/lib/form';

export default defineComponent({
  name: 'cForm',
  components: {
    ElForm,
  },
  setup(props, context: SetupContext) {
    const form: Ref<Element | null> = ref(null);

    onMounted((): void => {
      context.emit('update:form-ref', form.value);
    });

    return {
      form,
    };
  },
});
